// Mock data for JR Barber shop
export const shopInfo = {
  name: 'JR Barber',
  tagline: 'Barbier & Coiffeur — Toulouse',
  address: '271 Rte de Narbonne, 31400 Toulouse',
  phone: '07 87 55 81 71',
  instagram: 'jrbarber31',
  instagramUrl: 'https://www.instagram.com/jr_barber31',
  planityUrl: 'https://www.planity.com/jr-barber-31400-toulouse',
  rating: 4.7,
  reviewsCount: 236,
  established: 2018,
};

// Real photos of the salon
export const IMG_SALON = 'https://customer-assets.emergentagent.com/job_barbershop-pro-53/artifacts/34wygvga_image.png';
export const IMG_JONATHAN = 'https://customer-assets.emergentagent.com/job_barbershop-pro-53/artifacts/dfnidpea_image.png';
export const IMG_CUT = 'https://customer-assets.emergentagent.com/job_barbershop-pro-53/artifacts/dhjypxqe_image.png';

export const heroImages = [
  IMG_SALON,
  IMG_CUT,
  IMG_JONATHAN,
];

export const salonImage = IMG_SALON;

// Real prices from the shop poster
export const services = [
  { id: 1, name: 'Shampooing', description: 'Shampooing lavant et soin capillaire.', price: 3, duration: '10 min', popular: false },
  { id: 2, name: 'Coupe', description: 'Coupe personnalisée aux ciseaux et à la tondeuse.', price: 20, duration: '30 min', popular: false },
  { id: 3, name: 'Coupe -18 ans / Étudiant·e', description: 'Tarif réduit pour les moins de 18 ans et étudiants (justificatif).', price: 18, duration: '30 min', popular: false },
  { id: 4, name: 'Barbe', description: 'Taille de barbe, contours au rasoir, serviette chaude.', price: 15, duration: '20 min', popular: false },
  { id: 5, name: 'Coupe & Barbe', description: 'Notre prestation signature : coupe complète + taille de barbe.', price: 30, duration: '45 min', popular: true },
  { id: 6, name: 'Coupe & Barbe Premium', description: 'Version premium avec soins, serviette chaude et finitions au rasoir.', price: 38, duration: '60 min', popular: true },
  { id: 7, name: 'Rasage de crâne traditionnel', description: 'Rasage complet du crâne au rasoir, à l’ancienne.', price: 22, duration: '30 min', popular: false },
  { id: 8, name: 'Dessin (à partir de)', description: 'Motifs, traits ou designs personnalisés à la tondeuse.', price: 3, duration: '10 min', popular: false, from: true },
  { id: 9, name: 'Coupe Transformation', description: 'Changement de style complet, conseil et relooking.', price: 30, duration: '50 min', popular: false },
];

export const team = [
  {
    id: 1,
    name: 'Jonathan Richard',
    role: 'Fondateur & Master Barber',
    experience: '15 ans',
    speciality: 'Dégradés & barbes',
    image: IMG_JONATHAN,
  },
  {
    id: 2,
    name: 'Karim B.',
    role: 'Barbier Senior',
    experience: '8 ans',
    speciality: 'Cheveux afro',
    image: 'https://images.pexels.com/photos/16997937/pexels-photo-16997937.jpeg?auto=compress&cs=tinysrgb&w=940',
  },
  {
    id: 3,
    name: 'Lucas M.',
    role: 'Coiffeur',
    experience: '5 ans',
    speciality: 'Coupes modernes',
    image: 'https://images.unsplash.com/photo-1629189784191-9afdcbcb0398?crop=entropy&cs=srgb&fm=jpg&q=85&w=940',
  },
  {
    id: 4,
    name: 'Malik T.',
    role: 'Barbier',
    experience: '6 ans',
    speciality: 'Rasage traditionnel',
    image: 'https://images.unsplash.com/photo-1647140655214-e4a2d914971f?crop=entropy&cs=srgb&fm=jpg&q=85&w=940',
  },
];

export const gallery = [
  IMG_CUT,
  IMG_SALON,
  IMG_JONATHAN,
];

// Real hours from the poster
export const hours = [
  { day: 'Lundi', hours: '12:00 – 19:00', mode: 'Sur rendez-vous via Planity' },
  { day: 'Mardi', hours: '10:00 – 19:00', mode: 'Sur rendez-vous via Planity' },
  { day: 'Mercredi', hours: '10:00 – 19:00', mode: 'Sur rendez-vous via Planity' },
  { day: 'Jeudi', hours: '10:00 – 19:00', mode: 'Sur rendez-vous via Planity' },
  { day: 'Vendredi', hours: '09:00 – 19:00', mode: 'Sans rendez-vous uniquement' },
  { day: 'Samedi', hours: '09:00 – 18:00', mode: 'Sans rendez-vous uniquement' },
  { day: 'Dimanche', hours: 'Fermé', mode: '' },
];

export const reviews = [
  {
    id: 1,
    author: 'Antoine D.',
    rating: 5,
    date: 'il y a 2 semaines',
    text: 'Salon au top, Jonathan est un vrai perfectionniste. Coupe et barbe impeccables à chaque passage. Je recommande vivement !',
  },
  {
    id: 2,
    author: 'Mehdi K.',
    rating: 5,
    date: 'il y a 1 mois',
    text: 'Excellent accueil, ambiance conviviale et travail soigné. Le dégradé est parfait, les finitions au rasoir un vrai plus.',
  },
  {
    id: 3,
    author: 'Thomas L.',
    rating: 5,
    date: 'il y a 3 semaines',
    text: 'Je viens depuis un an, jamais déçu. Équipe pro, écoute des demandes et resultat toujours nickel.',
  },
  {
    id: 4,
    author: 'Julien P.',
    rating: 4,
    date: 'il y a 2 mois',
    text: 'Très bon salon, un peu d\'attente le samedi mais ça vaut le coup. La taille de barbe est superbe.',
  },
  {
    id: 5,
    author: 'Ryan M.',
    rating: 5,
    date: 'il y a 5 jours',
    text: 'Meilleur barbier de Toulouse pour moi. Cheveux afro parfaitement maîtrisés, je recommande à 100%.',
  },
  {
    id: 6,
    author: 'Sacha B.',
    rating: 5,
    date: 'il y a 1 semaine',
    text: 'Ambiance chill, musique, café offert. On repart avec le sourire et une coupe au top.',
  },
];
